import { dataPersistence } from './dataPersistence'
import {
  DEMO1_RELINQUISHED,
  DEMO1_SALES_PRICE,
  DEMO1_EXCHANGER,
  DEMO1_LEGAL_ENTITY,
  DEMO1_CLOSING_COMPANY_SALE,
  DEMO1_DISBURSEMENT,
  DEMO1_ESCROW_FILE_NUMBER,
  daysFromNow,
} from '@open1031/shared/demo/demo1'

export interface ExtractedData {
  firstName?: string
  lastName?: string
  email?: string
  phone?: string
  address?: {
    street?: string
    city?: string
    state?: string
    zipCode?: string
  }
  dateOfBirth?: string
  ssn?: string
  propertyAddress?: {
    street?: string
    city?: string
    state?: string
    zipCode?: string
  }
  relinquishedClosingDate?: string
  relinquishedSalePrice?: number
  relinquishedSellingExpenses?: number
  buyerName?: string
  exchangerNames?: string
  buyerNames?: string
  closingCompanyName?: string
  closingCompanyAddress?: string
  [key: string]: any
}

export const documentExtraction = {
  simulateExtraction: async (
    _file: File,
    documentType: 'id' | 'property' | 'closing' | 'other' | 'settlement-statement' | 'purchase-agreement' | 'title-report' | 'wire-instructions',
  ): Promise<ExtractedData> => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const cached = dataPersistence.getAll()
        let extracted: ExtractedData = {}
        if (documentType === 'id') {
          extracted = {
            firstName: cached.firstName || 'John',
            lastName: cached.lastName || 'Doe',
            dateOfBirth: cached.dateOfBirth || '1980-01-15',
            address: cached.address || {
              street: '123 Main St',
              city: 'Los Angeles',
              state: 'CA',
              zipCode: '90001',
            },
          }
        } else if (documentType === 'property') {
          extracted = {
            propertyAddress: cached.propertyAddress || {
              street: '456 Oak Avenue',
              city: 'Beverly Hills',
              state: 'CA',
              zipCode: '90210',
            },
          }
        } else if (documentType === 'closing') {
          extracted = {
            firstName: cached.firstName || 'John',
            lastName: cached.lastName || 'Doe',
            email: cached.email || 'john.doe@example.com',
            phone: cached.phone || '(555) 123-4567',
            address: cached.address || {
              street: '123 Main St',
              city: 'Los Angeles',
              state: 'CA',
              zipCode: '90001',
            },
          }
        } else if (documentType === 'settlement-statement') {
          const sellingExpenses = Math.round(DEMO1_SALES_PRICE * 0.03)
          extracted = {
            relinquishedClosingDate: daysFromNow(-2),
            relinquishedSalePrice: DEMO1_SALES_PRICE,
            relinquishedSellingExpenses: sellingExpenses,
            buyerName: `${DEMO1_EXCHANGER.firstName} ${DEMO1_EXCHANGER.lastName} / ${DEMO1_LEGAL_ENTITY}`,
            closingCompanyName: DEMO1_CLOSING_COMPANY_SALE.name,
            closingCompanyAddress: DEMO1_CLOSING_COMPANY_SALE.address,
            propertyAddress: {
              street: DEMO1_RELINQUISHED.street,
              city: DEMO1_RELINQUISHED.city,
              state: DEMO1_RELINQUISHED.state,
              zipCode: DEMO1_RELINQUISHED.zip,
            },
          }
        } else if (documentType === 'title-report') {
          const cachedCompany = (cached.closingCompanySale as { name?: string; address?: string; phone?: string; closerName?: string; closerEmail?: string } | undefined)
          extracted = {
            closingCompanyName: cachedCompany?.name || DEMO1_CLOSING_COMPANY_SALE.name,
            closingCompanyAddress: cachedCompany?.address || DEMO1_CLOSING_COMPANY_SALE.address,
            closingCompanyPhone: cachedCompany?.phone || DEMO1_CLOSING_COMPANY_SALE.phone,
            closerName: cachedCompany?.closerName || DEMO1_CLOSING_COMPANY_SALE.closerName,
            closerEmail: cachedCompany?.closerEmail || DEMO1_CLOSING_COMPANY_SALE.closerEmail,
            propertyAddress: cached.propertyAddress || undefined,
          }
        } else if (documentType === 'wire-instructions') {
          const exchangerFullName = cached.firstName && cached.lastName
            ? `${cached.firstName} ${cached.lastName}`
            : (cached.exchangerNames as string | undefined) || ''
          extracted = {
            exchangerNames: exchangerFullName || undefined,
            wireRecipient: DEMO1_DISBURSEMENT.wireRecipient,
            wireRecipientAddress: DEMO1_DISBURSEMENT.wireRecipientAddress,
            wireRecipientBankName: DEMO1_DISBURSEMENT.wireRecipientBankName,
            wireRecipientBankABA: DEMO1_DISBURSEMENT.wireRecipientBankABA,
            wireRecipientBankAccount: DEMO1_DISBURSEMENT.wireRecipientBankAccount,
            beneficiaryName: DEMO1_DISBURSEMENT.beneficiaryName,
            referenceNumber: DEMO1_ESCROW_FILE_NUMBER,
          }
        } else if (documentType === 'purchase-agreement') {
          const exchangerFullName = cached.firstName && cached.lastName
            ? `${cached.firstName} ${cached.lastName}`
            : (cached.exchangerNames as string | undefined) || ''
          const resolvedBuyerNames = (cached.buyerNames as string | undefined)
            || cached.buyerName
            || ''
          extracted = {
            exchangerNames: exchangerFullName || undefined,
            buyerNames: resolvedBuyerNames || undefined,
            sellerName: 'Roxbury DST Manager LLC',
            sellerAcknowledgmentSigner: 'Thomas C. Hargrove, Managing Director',
            closingCompanyName: 'Pacific Title & Escrow — Beverly Hills',
            closingCompanyAddress: '3300 Demo Avenue, Suite 800, Beverly Hills, CA 90210',
            closingCompanyPhone: '3105550155',
            closingCompanyEmail: 'closings@pacifictitle1031.example.com',
            closerName: 'Michael Torres',
            closerEmail: 'michael.torres@pacifictitle1031.example.com',
            purchaseAgreementDate: daysFromNow(-10),
            closingDate: daysFromNow(60),
            purchasePrice: DEMO1_SALES_PRICE,
            propertyAddress: {
              street: '2026 Sample Plaza',
              city: 'Beverly Hills',
              state: 'CA',
              zipCode: '90210',
            },
          }
        }
        dataPersistence.merge(extracted)
        resolve(extracted)
      }, 2000)
    })
  },

  extractFromPDF: async (file: File): Promise<ExtractedData> => {
    return documentExtraction.simulateExtraction(file, 'other')
  },
}


